import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./course_screen.module.scss";

export const CourseLoadingScreen = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.headingWrapper}>
        <div className={styles.headingLeft}>
          <div className={styles.image_wrapper}>
            <Skeleton height={80} width={150} />
          </div>
          <div>
            <Skeleton height={30} width="100%" className={styles.heading} />
            <Skeleton count={3} height={15} width="100%" />
          </div>
        </div>
        <div>
          <div>
            <Skeleton height={15} width={50} style={{ float: "right" }} />
            <Skeleton height={15} width={50} style={{ float: "right" }} />
          </div>
        </div>
      </div>
      <Skeleton height={30} width="100%" className={styles.table_heading} />
      <Skeleton count={4} height={15} width="100%" />
    </div>
  );
};

export default CourseLoadingScreen;
